import React, { useCallback, useEffect, useRef, useState } from 'react';
import u1 from '../../../assets/u1.png';
import u2 from '../../../assets/u2.png';
import u3 from '../../../assets/u3.png';
import { motion } from 'framer-motion';
import { container } from '../../Form/animation';
import Heading from '../../controls/Heading';
import Card from '../../HomePage/Feedback/Card';
import { TeamCardButton } from '../TeamCardButton';
import StyleButton from '../../controls/StyleButton';
import { Link } from 'gatsby';

function Feedback() {
  const data = [
    {
      id: '1',
      name: 'Tracy Weiler',
      image: u1,
      text: 'We had a great experience working with Rob. He responded to all our questions quickly and efficiently. He is very friendly, helpful, knowledgeable and professional through the whole process. Highly recommended!'
    },
    {
      id: '2',

      name: 'Larry Pearce',
      image: u2,
      text: 'From the moment I applied on line, I received my call the next day from a friendly and knowledgeable person. He worked with us through the process of securing the mortgage to purchase the home we already live in.'
    },
    {
      id: '3',

      name: 'Jamie Andre',
      image: u3,
      text: 'This was the most refreshing financial experience I have had thus far in my years of owning multiple properties. Nuborrow took the time to cater options that suited my needs and walked me through how to not only help mine and my families financial health but also learn how to use the equity in my home to my benefit.'
    }
  ];
  const cardRef = useRef<HTMLDivElement>(null);
  const singleCardRef = useRef<HTMLDivElement>(null);
  const cardWidth = useRef<number>(0);

  const handleNext = () => {
    const el = document.getElementById('slider');
    const widthCard = cardWidth.current || 300;
    el ? (el.scrollLeft += widthCard + 16) : '';
  };

  const handlePrev = () => {
    const el = document.getElementById('slider');
    const widthCard = cardWidth.current || 300;
    el ? (el.scrollLeft -= widthCard + 16) : '';
  };
  const handleResize = () => {
    if (singleCardRef.current && singleCardRef.current.firstChild instanceof HTMLElement) {
      cardWidth.current = (singleCardRef.current.firstChild as HTMLElement).clientWidth;
    }
  };

  const [buttonDisabled, setButtonDisabled] = useState({
    prev: false,
    next: false
  });

  const handleScrollReviews = useCallback(() => {
    const el = document.getElementById('slider');
    if (el) {
      setButtonDisabled({
        prev: el.scrollLeft === 0,
        next: Math.round(el.scrollLeft + el.clientWidth) >= el.scrollWidth
      });
    }
  }, []);
  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    const el = document.getElementById('slider');
    if (el) {
      el.addEventListener('scroll', handleScrollReviews);
    }
    handleScrollReviews();
    return () => {
      window.removeEventListener('resize', handleResize);
      if (el) {
        el.removeEventListener('scroll', handleScrollReviews);
      }
    };
  }, []);

  return (
    <div className="mx-auto flex flex-col justify-center py-6 lg:py-20">
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="visible"
        className="mx-6 flex flex-col justify-between gap-4 p-2 py-4 md:flex-row"
      >
        <Heading
          text={<p>Featured Reviews</p>}
          className="px-0 sm:px-0 md:px-2 md:text-center md:leading-[56.35px]"
        />

        <div className="flex gap-2">
          <TeamCardButton
            onClick={handlePrev}
            disabled={buttonDisabled.prev}
            className={`${buttonDisabled.prev ? 'bg-white text-brand' : ' bg-brand  text-white'}`}
            rotate={'rotate-90'}
          />
          <TeamCardButton
            onClick={handleNext}
            disabled={buttonDisabled.next}
            className={`${buttonDisabled.next ? 'bg-white text-brand' : 'bg-brand text-white'}`}
            rotate={'-rotate-90'}
          />
        </div>
      </motion.div>
      <div
        id="slider"
        onScroll={handleScrollReviews}
        ref={cardRef}
        className="scrollbar mx-auto flex w-full snap-x snap-mandatory items-center overflow-x-auto overflow-y-hidden scroll-smooth md:w-11/12 lg:flex lg:justify-start lg:overflow-x-scroll xl:overflow-x-scroll 2xl:overflow-x-scroll"
      >
        <div className="flex flex-row">
          {data.map((card, index: number) => (
            <div
              ref={singleCardRef}
              id={index.toString()}
              key={index}
              className="w-screen md:w-[500px] lg:w-[700px] xl:w-[800px] 2xl:w-[850px]"
            >
              <Card Name={card.name} image={card.image} content={card.text} />
            </div>
          ))}
        </div>
      </div>
      <div className="text-center">
        <Link to="https://www.google.com/search?gs_ssp=eJzj4tFP1zcsKCkrrjLKLTBgtFI1qLCwMEoySkyyTDU0NTdKMze3MqhIszQ1NjBIMU5MTjJOSU5N9uLIK03KLyrKLwcAVgsTbQ&q=nuborrow&oq=nubo&gs_lcrp=EgZjaHJvbWUqDQgCEC4YrwEYxwEYgAQyBggAEEUYPDIGCAEQRRg5Mg0IAhAuGK8BGMcBGIAEMgYIAxBFGDwyBggEEEUYPDIGCAUQRRg8MgYIBhBFGDwyBggHEEUYQdIBCDY3MzVqMGo3qAIAsAIA&sourceid=chrome&ie=UTF-8&bshm=rime/1#lrd=0x882b2ab9e1572f77:0xf95300d3acb3dcec,1,,,,">
          {' '}
          <StyleButton text="View all Google Reviews" />
        </Link>
      </div>
    </div>
  );
}

export default Feedback;
